import type { ReactNode } from "react";
import { Link } from "../atoms/Link";
import { cn } from "../lib/cn";

export interface FooterLink {
	label: string;
	href: string;
}

export interface AppFooterProps {
	links?: FooterLink[];
	/** Plain-language trust context, rendered as a muted lead paragraph. */
	description?: ReactNode;
	disclaimer?: ReactNode;
	className?: string;
}

function AppFooter({
	links = [],
	description,
	disclaimer,
	className,
}: AppFooterProps): ReactNode {
	return (
		<footer
			className={cn(
				"border-t border-border bg-background px-4 py-6",
				className,
			)}
		>
			<div className="flex flex-col gap-3">
				{description && (
					<div className="max-w-2xl text-sm text-mutedForeground">
						{description}
					</div>
				)}
				<div className="flex flex-wrap items-center justify-between gap-4">
					{links.length > 0 && (
						<nav
							aria-label="Footer navigation"
							className="flex flex-wrap gap-4"
						>
							{links.map((link) => (
								<Link
									key={link.href}
									href={link.href}
									className="text-sm text-mutedForeground"
								>
									{link.label}
								</Link>
							))}
						</nav>
					)}
					{disclaimer && (
						<div className="text-xs text-mutedForeground">{disclaimer}</div>
					)}
				</div>
			</div>
		</footer>
	);
}
AppFooter.displayName = "AppFooter";

export default AppFooter;
export { AppFooter };
